import React from 'react'

const SearchIcon: React.FC = (props: any = {}) => {
    return (
        <svg width="20" height="20" {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="9.58317" cy="9.58268" r="7.91667" stroke="#007AFF" stroke-width="1.25" />
            <path d="M15.4165 15.416L18.3332 18.3327" stroke="#007AFF" stroke-width="1.25" stroke-linecap="round" />
        </svg>

    )
}

export default SearchIcon